import { useAsyncError } from "react-router-dom";
const CaptureAsyncError = ({ errorTrackingClient }) => {
  const asyncError = useAsyncError();
  if (asyncError) {
    errorTrackingClient.captureException(asyncError);
  }
  return "";
};
export {
  CaptureAsyncError
};
//# sourceMappingURL=CaptureAsyncError.js.map
